window.evdnceApplyCarouselImages = function(g) {
  var gender = g || sessionStorage.getItem('evdnce_gender');
  document.querySelectorAll('.swiper-slide:has(.section-carousel__media)').forEach(function(slide) {
    var media = slide.querySelector('.section-carousel__media');
    var womenImg = media ? media.querySelector('[data-carousel-women-img]') : null;
    var defaultImg = media ? media.querySelector('img:not([data-carousel-women-img])') : null;

    if (gender === 'women') {
      if (womenImg) {
        // Has a women's image — show it, hide the default
        womenImg.style.display = 'block';
        if (defaultImg) defaultImg.style.opacity = '0';
        slide.style.display = '';
      } else {
        // No women's image — hide the entire slide
        slide.style.display = 'none';
      }
    } else {
      // Men's/default — show default, hide women's
      if (womenImg) womenImg.style.display = 'none';
      if (defaultImg) defaultImg.style.opacity = '';
      slide.style.display = '';
    }
  });

  // Update swiper after hiding/showing slides
  var swiperEl = document.querySelector('.section-carousel .swiper');
  if (swiperEl && swiperEl.swiper) {
    swiperEl.swiper.update();
    swiperEl.swiper.slideTo(0, 0);
  }
};

(function() {
  function init() {
    if (typeof window.evdnceApplyCarouselImages === 'function') {
      window.evdnceApplyCarouselImages();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 500);
})();